import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const InlineLinkButton = styled(Button)({
  padding: 0,
  minWidth: 'auto',
  fontSize: 'inherit',
  textDecoration: 'underline',
});
